export default "__VITE_ASSET__BFBntz_Y__"